import _defineProperty from "/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaults = {
  stringifier: JSON.stringify,
  fallbackMsg: "Could not stringify the given input."
};
/**
 * Stringify any given input withouth throwing an error.
 *
 * Order of proceeding:
 *  - try to call .toString() on it
 *  - try to parse it with a stringifier (JSON.stingify by default)
 *  - return a fallback string.
 */

export var stringifyAnything = function stringifyAnything(input, options) {
  var fullOptions = _objectSpread(_objectSpread({}, defaults), {}, {
    options: options
  });

  try {
    return input.toString();
  } catch (err) {
    /*
     * While using try/catch for control flow is not ideal,
     *  I didn't find a better way to check for an existing toString().
     */
  }

  try {
    return fullOptions.stringifier(input);
  } catch (err) {
    return fullOptions.fallbackMsg;
  }
};